import { useEffect, useRef, useState } from "react";
import { Box } from "@chakra-ui/react";

import { ChildrenFC } from "src/types/types";

const IntersectionObserverWrapper: ChildrenFC = ({ children }) => {
  const targetRef = useRef(null);
  const [isIntersecting, setIsIntersecting] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        setIsIntersecting(true);
        setIsLoaded(true);
      } else {
        setIsIntersecting(false);
      }
    });

    if (targetRef.current) {
      observer.observe(targetRef.current);
    }

    return () => {
      if (targetRef.current) {
        observer.unobserve(targetRef.current);
      }
    };
  }, []);

  return (
    <Box ref={targetRef}>{isIntersecting || isLoaded ? children : null}</Box>
  );
};

export default IntersectionObserverWrapper;
